import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import withRouterCompat from '../../actions/routerWrapper'
import axios from 'axios';
import GridItem from "../Grid/GridItem.jsx";
import GridContainer from "../Grid/GridContainer.jsx";
import Card from "../Card/Card.jsx";
import * as yup from 'yup';
import CardHeader from "../Card/CardHeader.jsx";
import {  useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { baseUrl } from '../../components/shared/baseUrl';
import CardBody from "../../components/Card/CardBody";
import {  Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import Button from "../CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';


const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      textAlign:"center"
    }
  });


  const validationSchema = yup.object().shape({
  
    pass: yup
      .string()
      .required("Password is required")
      .min(4, "Too Short")
      .max(15, "Too Long!"),
  
    repass: yup
        .string()
        .when("pass", {
            is: val => (val && val.length>0 ? true : false),
            then:yup.string().oneOf(
                [yup.ref("pass")],
                "passwords must match"
            )
        }).required("Please Confirm your Password")

  
    
  })

function ForgotPass(props){
   
    const otpdetails = useSelector(state => state.otptime)
    const dispatch = useDispatch();


    console.log(otpdetails)
    const theme = useTheme()
    const classes = styles(theme);
    const [email, setemail] = React.useState('');
    const [error, seterror] = React.useState('');
    const [otp, setOtp] = React.useState('');
    const [Otpvalid, setOtpvalid] = React.useState('0');


    

    const CheckValidEmail= () =>{
        console.log(email)
        var otp = Math.floor(1000 + (9999-1000)*Math.random());

        const data = {
            username:email,
            otp:otp
        }

        console.log(data)
      let url = `${baseUrl}checkusername`;  
      axios.post(url, data)
      .then(response => {        
        console.log(response.data)
        seterror('')
        const obj = {
            otp:otp,
            currentTime:new Date(),
            username:email
        }

        dispatch({
            type:'SET_OTP',
            payload:obj
        
        });
        setOtpvalid('1')

      
      })
      .catch(errors => 
        seterror('User is not registered')
       // console.log(errors)
        )
    }

    const ResendOtp= () =>{
        console.log(email)

        const data = {
            username:otpdetails.username,
            otp:otpdetails.otp
        }

        console.log(data)
      let url = `${baseUrl}checkusername`;  
      axios.post(url, data)
      .then(response => {        
        console.log(response.data)
        seterror('')
        setOtpvalid('1')
      
      })
      .catch(errors => 
        seterror('User is not registered')
       // console.log(errors)
        )
    }

    const CheckValidOtp= () =>{
        
        var otpCreated = new Date(otpdetails.currentTime);
        var current = new Date();
        var diff = current - otpCreated
        var diffMins = Math.round(((diff % 86400000) % 3600000) / 60000);
        
        console.log(diffMins)

        if(diffMins <= 10)
        {
        if(otpdetails.otp.toString() === otp ){
            console.log('Otp Matched');
            seterror('Otp correct');

            setOtpvalid('2');
        }
        else{
            console.log('Not matched');
            seterror('Please enter correct otp');
        }
        }
        else{
            console.log('Time over')
            seterror('otp expired');

        }
        
       
    }


    const onChange = (event) => {
        setemail(event.target.value);

      }
      const onOtpChange = (event) => {
        setOtp(event.target.value);

      }
   
    return(

        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardHeader color="primary">
                            {/* <h4 className={classes.cardTitleWhite}>Create new Module</h4> */}
                            <h4 className={classes.cardTitleWhite}>Set Password here</h4>
                    </CardHeader>
                    
                <Formik
                    initialValues={{
                    email: '',
                    otp:'',
                    pass:'',
                    repass:'',
                    }}

                    validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {
                        setSubmitting(false);
                        
                        
                        alert(JSON.stringify(values, null, 2));

                         const passDetails = {
                            username:otpdetails.username,
                            password: values.repass,
                            
                        }
                        console.log(passDetails);
                        axios.post(`${baseUrl}forgotpass`, passDetails)
                        .then(res => 
                            {
                                
                                console.log(res.data) 
                                //seterror(res.data) 
                                dispatch({
                                    type:'RESET_OTP'                                
                                });
                                setOtpvalid('5');
                                seterror('Password reset successful/Go to Landing page for login');

 
                            });

                    }, 500);
                    }}
                >

            {({submitForm, isSubmitting, touched, errors}) => (
                <Form>
                <CardBody>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                    <Link color="inherit" to="/adi">
                        <Typography gutterBottom variant="h6" component="h4">
                                Go to Landing Page
                        </Typography>
                    </Link>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    {otpdetails.username ===''?

                        <Field
                            component={TextField}
                            type="text"
                            label="Enter registered email"
                            name="email"
                            value={email}
                            fullWidth= {true} 
                            onChange={onChange}
                            //validate={validateEmail}
                        />
                        :
                <div><h4> Email:{otpdetails.username}</h4> 
                <p>An otp has been sent to your email.</p>
                        <Button
                            variant="contained"
                            color="rose"
                            size='sm'
                            onClick={ResendOtp}
                            >
                            Resend
                        </Button>
                </div>        
                        }
                        {error}

                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                    {otpdetails.username ===''?

                        <Button
                            variant="contained"
                            color="warning"
                            onClick={CheckValidEmail}
                            >
                            Submit
                        </Button>:null}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    {otpdetails.username !==''?
                        <Field
                            component={TextField}
                            type="text"
                            label="Enter otp here"
                            name="otp"
                            value={otp}
                            fullWidth= {true} 
                            onChange={onOtpChange}
                            //validate={validateEmail}
                        />:null}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                    {otpdetails.username !==''?

                        <Button
                            variant="contained"
                            color="rose"
                            onClick={CheckValidOtp}
                            >
                            Submit
                        </Button>
                        :null}



                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    </GridItem>
              
                    <GridItem xs={12} sm={12} md={4}>
                        
                    {Otpvalid ==='2'?
                    
                    <Field
                        component={TextField}
                        type="password"
                        label="Enter your new Password"
                        name="pass"
                        fullWidth= {true}
                        
                      />:null}
                      </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                    {Otpvalid ==='2'?
                      <Field
                        component={TextField}
                        type="password"
                        label="Re-enter your new Password"
                        name="repass"
                        id="repass"
                        fullWidth= {true}
                        
                    />:null}
                    </GridItem>
                    
                </GridContainer>
                </CardBody>
                <GridContainer>
                
                    <GridItem xs={12} sm={12} md={4}>
                    </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                {Otpvalid ==='2'?
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={ isSubmitting}
                        onClick={submitForm}
                        >
                    Submit
                    </Button>:null}
                </GridItem>
                </GridContainer>
                </Form>
                )}
                </Formik>
                </Card>
            </GridItem>
        </GridContainer>
    );
}

export default withRouterCompat(ForgotPass);
